import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withRouter } from 'react-router-dom';
import { withTracker } from 'meteor/react-meteor-data';
import { filter, includes, isEmpty, isNil, map } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import { Bert } from 'meteor/themeteorchef:bert';

import LayersCollection, { LAYER_TYPES } from '../../../api/Layers/Layers';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import TimeFilter from '../../atoms/TimeFilter';
import MapContainerLayersList from '../../containers/MapContainerLayersList';
import LoadingIpsilum from '../LoadingIpsilum';
import TableList from '../TableList';

const PER_PAGE = 15;

class LayersList extends Component {
  state = {
    highlightedLayerId: '',
    isTrashOpen: false
  };

  changeHighlightedLayerId = newHighlightedLayerId =>
    this.setState({ highlightedLayerId: newHighlightedLayerId });

  closeTrash = () => this.setState({ isTrashOpen: false });

  handleDuplicate = layerId => {
    const { isBasic, isFree, unfilteredCount, deployConfig } = this.props;
    const duplicate = async () => {
      try {
        await methodPromise('layers.copy', layerId);
        Bert.alert('Layer Duplicated!', 'info');
      } catch (error) {
        handleErrorInClient(error);
      }
    };
    if (!isFree && !isBasic) {
      duplicate();
    } else if (isFree && unfilteredCount < deployConfig.Roles.Free.LayersLimit) {
      duplicate();
    } else if (isBasic && unfilteredCount < deployConfig.Roles.Basic.LayersLimit) {
      duplicate();
    } else {
      Bert.alert('You need to upgrade your plan to add more Layers', 'info');
    }
  };

  handleDownload = layerId => {
    const { isBasic, isFree, layerList } = this.props;
    const download = async () => {
      try {
        const layerSelected = layerList.find(index => index._id === layerId);
        const filename = `${layerSelected.name}.json`;
        const json = JSON.stringify(layerSelected, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const enlaceDescarga = document.createElement('a');
        enlaceDescarga.href = url;
        enlaceDescarga.download = filename;
        enlaceDescarga.click();
        URL.revokeObjectURL(url);

        Bert.alert('Layer download!', 'info');
      } catch (error) {
        handleErrorInClient(error);
      }
    };
    if (!isFree && !isBasic) {
      download();
      // } else if (isFree && unfilteredCount < deployConfig.Roles.Free.LayersLimit) {
      //   download();
      // } else if (isBasic && unfilteredCount < deployConfig.Roles.Basic.LayersLimit) {
      //   download();
    } else {
      Bert.alert('You need to upgrade your plan to add more Layers', 'info');
    }
  };

  handleHardRemove = async layerId => {
    try {
      await methodPromise('layers.hardDelete', layerId);
      Bert.alert('Layer deleted!', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleRestore = layerId => {
    const { isBasic, isFree, unfilteredCount, deployConfig } = this.props;

    const restore = async () => {
      try {
        await methodPromise('layers.restore', layerId);
        Bert.alert('Layer Restored!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    };

    if (!isFree && !isBasic) {
      restore();
    } else if (isFree && unfilteredCount < deployConfig.Roles.Free.LayersLimit) {
      restore();
    } else if (isBasic && unfilteredCount < deployConfig.Roles.Basic.LayersLimit) {
      restore();
    } else {
      Bert.alert('You need to upgrade your plan to add more Layers', 'info');
    }
  };

  handleSoftRemove = async layerId => {
    try {
      await methodPromise('layers.softDelete', layerId);
      Bert.alert('Layer moved to Trash!', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openTrash = () => this.setState({ isTrashOpen: true });

  render() {
    const {
      currentPage,
      defaultBaseMap,
      deletedCount,
      deletedLayers,
      filterOptions,
      history,
      isFree,
      isBasic,
      isPremium,
      layerList,
      loading,
      match,
      searching,
      sort,
      totalCount,
      unfilteredCount,
      changePage,
      handleSearch,
      handleSort,
      userControlSetting,
      roles
    } = this.props;
    const { highlightedLayerId, isTrashOpen } = this.state;
    const uploadGeojson =
      !isEmpty(userControlSetting) &&
      userControlSetting.uploadLayer.some(valor => roles.includes(valor));
    const downloadGeojson =
      !isEmpty(userControlSetting) &&
      userControlSetting.downloadLayer.some(valor => roles.includes(valor));
    const hasTrash =
      !isEmpty(userControlSetting) &&
      userControlSetting.hasTrash.some(valor => roles.includes(valor));
    const numberCreatedLayer = () => {
      let state = true;
      if (!isEmpty(userControlSetting)) {
        const properties = userControlSetting.numberLayersCreated;
        if (roles.includes('free-user')) {
          state = layerList.length < properties.free;
        } else if (roles.includes('basic-user')) {
          state = layerList.length < properties.basic;
        }
      }
      return state;
    };
    const tableHeaders = [
      {
        name: 'Layers',
        count: totalCount,
        filteredCount: unfilteredCount === totalCount ? '' : unfilteredCount - totalCount,
        sortValue: 'name'
      },
      {
        isHiddenOnXS: true,
        name: 'Last Updated',
        sortValue: 'updatedAt'
      },
      {
        isHiddenOnXS: true,
        name: 'Created',
        sortValue: 'createdAt'
      },
      {
        isButtonColumn: true
      },
      {
        isButtonColumn: true
      }
    ];
    if (downloadGeojson === true)
      tableHeaders.push({
        isButtonColumn: true
      });
    const newItems = [
      {
        isFreeUserAtLimit: false,
        newItemRoute: `${match.url}/new`,
        itemName: 'layers',
        eventKey: 1
      }
    ];
    const trashProps = {
      deletedCount,
      deletedItems: deletedLayers,
      isTrashOpen,
      closeTrash: this.closeTrash,
      deleteItem: this.handleHardRemove,
      restoreItem: this.handleRestore
    };
    const tablePageHeaderProps = {
      uploadGeojson,
      createdNewItem: numberCreatedLayer(),
      filterOptions,
      hasFilterButton: true,
      hasSearchInput: true,
      isPremium,
      layerList,
      newItems,
      searching,
      handleSearch
    };
    const tableHeaderRowProps = {
      hasTrash,
      sort,
      tableHeaders,
      handleSort,
      openTrash: this.openTrash
    };
    const tableContentProps = {
      downloadButton: downloadGeojson,
      duplicateButton: true,
      createdNewItem: numberCreatedLayer(),
      history,
      isTableEmpty: layerList.length === 0,
      itemName: 'layers',
      items: layerList,
      loading,
      match,
      numberOfColumns: 6,
      openNewTabButton: true,
      downloadItem: this.handleDownload,
      duplicateItem: this.handleDuplicate,
      hoverItem: this.changeHighlightedLayerId,
      softDeleteItem: this.handleSoftRemove
    };
    const tablePaginationProps = {
      currentPage,
      itemsPerPage: PER_PAGE,
      totalCount,
      changePage
    };
    if (!loading) {
      return (
        <Row>
          <Col xs={12} md={6}>
            <MapContainerLayersList
              layerList={layerList}
              filterOptions={filterOptions}
              highlightedLayerId={highlightedLayerId}
              defaultBaseMap={defaultBaseMap}
              {...this.props}
            />
            <TimeFilter {...filterOptions.time} />
          </Col>
          <Col xs={12} md={6}>
            <TableList
              childProps={{
                trashProps,
                tablePageHeaderProps,
                tableHeaderRowProps,
                tableContentProps,
                tablePaginationProps
              }}
              isFreeUserAtLimit={isFree || isBasic}
              isFree={isFree}
              isPaginationOn
            />
          </Col>
        </Row>
      );
    }
    return <LoadingIpsilum />;
  }
}

LayersList.defaultProps = {
  defaultBaseMap: {}
};

LayersList.propTypes = {
  layerList: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  defaultBaseMap: PropTypes.object,
  deletedCount: PropTypes.number.isRequired,
  deletedLayers: PropTypes.array.isRequired,
  filterOptions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isBasic: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  isPremium: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  searching: PropTypes.bool.isRequired,
  sort: PropTypes.object.isRequired,
  deployConfig: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  unfilteredCount: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  userControlSetting: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired
};

export default withRouter(
  withTracker(({ currentPage, filterOptions, searchValue, sort, userControlSetting }) => {
    const skip = currentPage * PER_PAGE - PER_PAGE;

    const layerQuery = { $and: [{ deleted: { $eq: 'no' } }] };

    const searchRegex = !isEmpty(searchValue) ? new RegExp(searchValue, 'i') : null;
    if (!isNil(searchRegex)) layerQuery.$and.push({ name: searchRegex });

    const { filterOn: timeFilterOn, dateRangeStart, dateRangeEnd } = filterOptions.time;
    if (timeFilterOn)
      layerQuery.$and.push({
        createdAt: { $gte: dateRangeStart, $lte: `${dateRangeEnd}T23:59:59.999Z` }
      });

    const { filterOn: locationFilterOn, boundingBox } = filterOptions.location;
    if (locationFilterOn)
      layerQuery.$and.push({
        $or: [
          {
            $and: [
              { 'mapLocation.bbox': { $exists: false } },
              {
                'mapLocation.geometry.coordinates.0': {
                  $gte: boundingBox[0][0],
                  $lte: boundingBox[1][0]
                }
              },
              {
                'mapLocation.geometry.coordinates.1': {
                  $gte: boundingBox[0][1],
                  $lte: boundingBox[1][1]
                }
              }
            ]
          },
          {
            $and: [
              { 'mapLocation.bbox.0': { $lte: boundingBox[1][0] } },
              { 'mapLocation.bbox.1': { $lte: boundingBox[1][1] } },
              { 'mapLocation.bbox.2': { $gte: boundingBox[0][0] } },
              { 'mapLocation.bbox.3': { $gte: boundingBox[0][1] } }
            ]
          }
        ]
      });

    const typeFilters = map(
      filter(
        filterOptions,
        ({ name, filterOn }) => !includes(['tags', 'date', 'location'], name) && filterOn
      ),
      ({ value }) => {
        const objectToReturn = {};
        objectToReturn[`layer${!includes(LAYER_TYPES, value) ? 'Sub' : ''}Type`] = value;
        return objectToReturn;
      }
    );
    if (!isEmpty(typeFilters)) layerQuery.$and.push({ $or: typeFilters });

    const sortOptions = { limit: PER_PAGE, skip, sort };

    const layersSub = Meteor.isClient && Meteor.subscribe('layers');

    return {
      loading: !layersSub.ready(),
      layerList: LayersCollection.find(layerQuery, sortOptions).fetch(),
      totalCount: LayersCollection.find(layerQuery).count(),
      unfilteredCount: LayersCollection.find({ deleted: { $eq: 'no' } }).count(),
      deletedLayers: LayersCollection.find({ deleted: { $ne: 'no' } }).fetch(),
      deletedCount: LayersCollection.find({ deleted: { $ne: 'no' } }).count(),
      defaultBaseMap: LayersCollection.findOne(userControlSetting.defaultBaseMap)
    };
  })(LayersList)
);
